<!-- Modal (Notas Fiscais (Sintéticas)) -->

<ng-template #notasFiscaisSinteticas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-notas-fiscais-sinteticas"><b>Notas fiscais e duplicatas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-modal-notas-fiscais [notasFiscais]="notasFiscais"></app-pedido-modal-notas-fiscais>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Tarefa) -->

<ng-template #gerenciarTarefa let-modal>
  <div class="modal-header pl-3">
    @if (eventoSelecionado == null) {
      <h3 class="modal-title" id="titulo-gerenciar-tarefa"><b>Nova (Tarefa)</b></h3>
    }
    @if (eventoSelecionado != null) {
      <h3 class="modal-title" id="titulo-gerenciar-tarefa"><b>Alterar (Tarefa)</b></h3>
    }

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="formFiltroCliente" (ngSubmit)="filtrarCliente()">
      <div class="form-row">
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Filtrar Cliente por:</b></label>

          <select class="form-control form-control-sm" name="filtrar_cliente_por" formControlName="filtro" (change)="alterarFiltroCliente($event.target.value)">
            @for (opcao of filtroClientes; track opcao) {
              <option [value]="opcao.valor" [selected]="opcao.valor == fc.filtro.value">{{ opcao.texto }}</option>
            }
          </select>
        </div>

        <!-- Código -->

        @if (fc.filtro.value == 0) {
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>Código:</b></label>
            <input class="form-control form-control-sm" type="number" min="1" step="1" name="cliente_filtrar_codigo" [ngClass]="{ 'is-invalid': enviadoCliente && fc.codigo.errors?.required }" formControlName="codigo" />
            @if (enviadoCliente && fc.codigo.errors?.required) {
              <div class="erro pt-1">Código em branco!</div>
            }
          </div>
        }

        <!-- CNPJ/CPF -->

        @if (fc.filtro.value == 1) {
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>CNPJ/CPF:</b></label>
            <input class="form-control form-control-sm" type="text" name="cliente_filtrar_cnpj_cpf" [ngClass]="{ 'is-invalid': enviadoCliente && fc.cnpj_cpf.errors?.required }" formControlName="cnpj_cpf" />
            @if (enviadoCliente && fc.cnpj_cpf.errors?.required) {
              <div class="erro pt-1">CNPJ/CPF em branco!</div>
            }
          </div>
        }

        <!-- Nome Fantasia -->

        @if (fc.filtro.value == 2) {
          <div class="form-group col-sm-4">
            <label class="text-secondary"><b>Nome Fantasia:</b></label>
            <input class="form-control form-control-sm" type="text" name="cliente_filtrar_nome_fantasia" [ngClass]="{ 'is-invalid': enviadoCliente && fc.nome_fantasia.errors?.required }" formControlName="nome_fantasia" />
            @if (enviadoCliente && fc.nome_fantasia.errors?.required) {
              <div class="erro pt-1">Nome Fantasia em branco!</div>
            }
          </div>
        }

        <!-- Razão Social -->

        @if (fc.filtro.value == 3) {
          <div class="form-group col-sm-4">
            <label class="text-secondary"><b>Razão Social:</b></label>
            <input class="form-control form-control-sm" type="text" name="cliente_filtrar_razao_social" [ngClass]="{ 'is-invalid': enviadoCliente && fc.razao_social.errors?.required }" formControlName="razao_social" />
            @if (enviadoCliente && fc.razao_social.errors?.required) {
              <div class="erro pt-1">Razão Social em branco!</div>
            }
          </div>
        }

        <div class="col-sm-3">
          <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>

          @if (filtrandoCliente) {
            <button class="btn btn-secondary btn_filtro" type="button" (click)="alterarFiltroCliente(null)">Cancelar</button>
          }
        </div>
      </div>

      <hr class="mt-2 mb-2" />

      @if (filtrandoCliente) {
        <div [@esvanecerDesvanecer]="'in'">
          <div class="filtrar_cliente p-1">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="filtrar_cliente_tabela" [itemSize]="10">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th class="text-center">Código</th>
                      <th class="tabela_borda">Cliente</th>
                      <th class="tabela_borda text-center">CNPJ/CPF</th>
                      <th class="tabela_borda">Endereço</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *cdkVirtualFor="let cliente of clientes; templateCacheSize: 0;">
                      <tr class="filtrar_cliente_acao" (click)="selecionarClienteFiltrado(cliente.codigo_no_erp_do_cliente)">
                        <td class="text-center">{{ cliente.codigo_no_erp_do_cliente }}</td>
                        <td class="tabela_borda">{{ cliente.name }}</td>
                        <td class="tabela_borda text-center">{{ cliente.client_document }}</td>
                        <td class="tabela_borda">{{ cliente.endereco_completo }}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
        </div>
      }

      <div class="form-row">
        <div class="form-group col-sm-2">
          <label><b>Código:</b></label>

          <input class="form-control form-control-sm" type="text" name="cliente_codigo" [value]="clienteSelecionado == null ? '' : clienteSelecionado.codigo_no_erp_do_cliente" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />
        </div>

        <div class="form-group col-sm-10">
          <label><b>Cliente:</b></label>

          <input class="form-control form-control-sm" type="text" name="cliente_razao_social" [value]="clienteSelecionado == null ? '' : clienteSelecionado.name" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />

          @if (clienteInvalido) {
            <div class="erro pt-1">Cliente em branco!</div>
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-sm-8">
          <label><b>Endereço:</b></label>

          <input class="form-control form-control-sm" type="text" name="cliente_endereco" [value]="clienteSelecionado == null ? '' : clienteSelecionado.endereco_completo" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />
        </div>

        <div class="form-group col-sm-2">
          <label><b>CNPJ/CPF:</b></label>

          <input class="form-control form-control-sm" type="text" name="cliente_cnpj_cpf" [value]="clienteSelecionado == null ? '' : clienteSelecionado.client_document" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />
        </div>

        <div class="form-group col-sm-2">
          <label>
            <b>Notas Fiscais:</b>

            @if (clienteSelecionado != null && clienteSelecionado.client_document != null && clienteSelecionado.client_document != '') {
              <i class="fa fa-info label_acao ml-2" placement="top" ngbTooltip="Notas Fiscais" (click)="modalNotasFiscaisSinteticas(notasFiscaisSinteticas, clienteSelecionado.client_document)"></i>
              &nbsp;
            }
          </label>

          <input class="form-control form-control-sm" type="text" name="cliente_status" [value]="clienteSelecionado == null ? '' : clienteSelecionado.status_financeiro != null ? 'INADIMPLENTE' : '-'" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />
        </div>
      </div>

      <hr class="mt-2 mb-2" />
    </form>

    <div class="form-row">
      <div class="form-group col-sm-4">
        <label><b>Vendedor(a):</b></label>

        <select class="form-control form-control-sm" name="vendedorTarefa" #vendedorTarefa (change)="selecionarVendedorTarefa(vendedorTarefa.value)">
          @for (opcao of vendedores; track opcao) {
            <option [value]="opcao.id" [selected]="vendedorTarefaSelecionado != null ? opcao.id == vendedorTarefaSelecionado.id : null">{{ opcao.fullname }}</option>
          }
        </select>
      </div>

      <div class="form-group col-sm-4">
        <label><b>Tipo:</b></label>

        <select class="form-control form-control-sm" name="tipo_tarefa" #tipo_tarefa (change)="selecionarTipoTarefa(tipo_tarefa.value)" [disabled]="eventoSelecionado != null">
          @for (opcao of tiposTarefa; track opcao) {
            <option [value]="opcao.id" [selected]="tipoTarefaSelecionada != null ? opcao.id == tipoTarefaSelecionada.id : null">{{ opcao.nome }}</option>
          }
        </select>
      </div>

      <div class="form-group col-sm-2">
        <label><b>Data:</b></label>

        <input class="form-control form-control-sm" type="text" name="tarefa_data" [ngClass]="{ 'is-invalid': tarefaDataInvalida }" ngbDatepicker #tarefa_data="ngbDatepicker" (click)="tarefa_data.toggle()" [(ngModel)]="tarefaData" />

        @if (tarefaDataInvalida) {
          <div class="erro pt-1">Data inválida!</div>
        }
      </div>

      <div class="form-group col-sm-2">
        <label><b>Hora:</b></label>

        <ngb-timepicker name="tarefa_hora" [spinners]="false" [(ngModel)]="tarefaHora"></ngb-timepicker>
      </div>
    </div>

    @if (tipoTarefaSelecionada != null && tipoTarefaSelecionada.nome != 'LIGAÇÃO') {
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label><b>Observação:</b></label>
          <textarea class="form-control form-control-sm" rows="1" name="tarefaObservacao" [(ngModel)]="tarefaObservacao"></textarea>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-sm-2">
          <label><b>Dt. Baixa:</b></label>
          <input class="form-control form-control-sm" type="text" name="tarefa_data_baixa" [ngClass]="{ 'is-invalid': tarefaDataBaixaInvalida }" ngbDatepicker #tarefa_data_baixa="ngbDatepicker" (click)="tarefa_data_baixa.toggle()" [(ngModel)]="tarefaDataBaixa" />
          @if (tarefaDataBaixaInvalida) {
            <div class="erro pt-1">Dt. Baixa inválida!</div>
          }
        </div>
        <div class="form-group col-sm-10">
          <label><b>Observação: (Baixa)</b></label>
          <textarea class="form-control form-control-sm" rows="1" name="tarefaObservacaoBaixa" [(ngModel)]="tarefaObservacaoBaixa"></textarea>
        </div>
      </div>
    }

    @if (tipoTarefaSelecionada != null && tipoTarefaSelecionada.nome == 'LIGAÇÃO') {
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label><b>Mensagem:</b></label>
          <textarea class="form-control form-control-sm" rows="1" name="ligacaoMensagem" [(ngModel)]="ligacaoMensagem"></textarea>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="pb-2" [@esvanecerDesvanecer]="'in'">
    <!-- Vendedor(a) -->
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Vendedor(a):</b></label>
        <select class="form-control form-control-sm" name="vendedor" #vendedor (change)="selecionarVendedor(vendedor.value)">
          <option value="0" [selected]="vendedorSelecionado == null"></option>
          @for (opcao of vendedores; track opcao) {
            <option [value]="opcao.id" [selected]="vendedorSelecionado != null ? opcao.id == vendedorSelecionado.id : null">{{ opcao.fullname }}</option>
          }
        </select>
      </div>
    </div>
    <hr class="mt-2 mb-2" />
    @if (vendedorSelecionado != null) {
      <!-- Título -->
      <div class="d-flex flex-wrap">
        <div class="btn-group">
          <div class="btn btn-secondary" mwlCalendarPreviousView [view]="visualizacao" [(viewDate)]="dataSelecionada" (viewDateChange)="alterarDataSelecionadaAberta()"><</div>
          <div class="btn btn-secondary" mwlCalendarToday [(viewDate)]="dataSelecionada">Hoje</div>
          <div class="btn btn-secondary" mwlCalendarNextView [view]="visualizacao" [(viewDate)]="dataSelecionada" (viewDateChange)="alterarDataSelecionadaAberta()">></div>
        </div>
        <div class="flex-grow-1 text-center">
          <h3 class="calendario_titulo">{{ dataSelecionada | calendarDate: (visualizacao + 'ViewTitle') : 'pt' }}</h3>
        </div>
        <div class="btn-group">
          <div class="btn btn-secondary" [class.active]="visualizacao == CalendarView.Month" (click)="alterarVisualizacao(CalendarView.Month)">Mês</div>
          <div class="btn btn-secondary" [class.active]="visualizacao == CalendarView.Week" (click)="alterarVisualizacao(CalendarView.Week)">Semana</div>
          <div class="btn btn-secondary" [class.active]="visualizacao == CalendarView.Day" (click)="alterarVisualizacao(CalendarView.Day)">Dia</div>
        </div>
        <div>
          <button class="btn btn-secondary btn_titulo" type="button" (click)="modalGerenciarTarefa(gerenciarTarefa, null)">Nova Tarefa</button>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      @if (!carregandoDadosEventos) {
        <div>
          @switch (visualizacao) {
            <!-- Mês -->
            @case (CalendarView.Month) {
              <mwl-calendar-month-view
                [viewDate]="dataSelecionada"
                [events]="eventos"
                [refresh]="atualizacao"
                [activeDayIsOpen]="dataSelecionadaAberta"
                (dayClicked)="selecionarDia($event.day)"
                (eventClicked)="monitorarEvento('Clicado', $event.event)"
                (eventTimesChanged)="alterarTempoEvento($event)">
              </mwl-calendar-month-view>
            }
            <!-- Semana -->
            @case (CalendarView.Week) {
              <mwl-calendar-week-view
                [viewDate]="dataSelecionada"
                [events]="eventos"
                [refresh]="atualizacao"
                (eventClicked)="monitorarEvento('Clicado', $event.event)"
                (eventTimesChanged)="alterarTempoEvento($event)">
              </mwl-calendar-week-view>
            }
            <!-- Dia -->
            @case (CalendarView.Day) {
              <mwl-calendar-day-view
                [viewDate]="dataSelecionada"
                [events]="eventos"
                [refresh]="atualizacao"
                (eventClicked)="monitorarEvento('Clicado', $event.event)"
                (eventTimesChanged)="alterarTempoEvento($event)">
              </mwl-calendar-day-view>
            }
          }
        </div>
      }
    }
  </div>
}
